/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3" v-if="page == 'view-level'">All Levels</h4>
        <h4 class="text-center font-weight-bold py-3" v-if="page == 'add-lesson'">Select Lesson Level</h4>
        <h4 class="text-center font-weight-bold py-3" v-if="page == 'edit-lesson'">Select Lesson Level</h4>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">Title</th>
                        <th scope="col">Points</th>
                        <th scope="col">Step</th>
                        <th scope="col">Target</th>
                        <th scope="col">Take Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="level in levels" :key="level._id">
                        <th>{{level.title}}</th>
                        <td>{{level.points}}</td>
                        <td>{{level.step}}</td>
                        <td>{{level.target}}</td>
                        <td>
                            <router-link :to="{ name: 'AddHomework', params : {levelId : level._id} }" v-if="page == 'add-homework'">
                                <button class="btn btn-primary btn-sm">Add Homework</button>
                            </router-link>

                            <router-link :to="{ name: 'Homeworks', params : {levelId : level._id} }" v-if="page == 'edit-homework'">
                                <button class="btn btn-info btn-sm">View/Edit Homework</button>
                            </router-link>

                            <router-link :to="{ name: 'EditLevel', params : {levelId : level._id} }" v-if="page =='view-level' ">
                                <button class="btn btn-primary btn-sm">Edit</button>
                            </router-link>

                            <router-link to="/delete-level" v-if="page =='view-level' ">
                                <button class="btn btn-danger btn-sm">Delete</button>
                            </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'Level',
    components: {

    },
    data() {
        return {
            levels: [],
            page: this.$route.params.page,
            category: this.$route.params.cat,
            baseUrl: "/levels",
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    mounted() {

        this.$toast.open({
            message: "Processing : Loading Levels Please Wait...",
            type: 'info'
        })

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }

        if (this.category == "RUNNER") {
            this.baseUrl = "/levels?category=RUNNER"
        } else if (this.category == "TODDLER") {
            this.baseUrl = "/levels?category=TODDLER"
        } else if (this.category == "all") {
            this.baseUrl = "/levels"
        } else {
            this.baseUrl = "/levels"
        }
        axios.get(this.$apiURI + this.baseUrl, config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.levels = response.data.data.levels
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    }
}
</script>
